import { format } from 'date-fns';

/**
 * Formats a date string or Date object into a specified format.
 * @param dateInput The date string or Date object to format.
 * @param formatStr The format string (e.g., 'd MMM yyyy'). Defaults to 'd MMM yyyy'.
 * @returns The formatted date string, or '-' if the input is null, undefined, or invalid.
 */
export const formatDate = (dateInput: string | Date | null | undefined, formatStr = 'd MMM yyyy'): string => {
  if (!dateInput) {
    return '-';
  }
  try {
    // @ts-ignore no-inferrable-types
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    return format(date, formatStr);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

export const getDuration = (startDate: string | null | undefined, endDate: string | null | undefined) => {
  if (!startDate || !endDate) return '-';
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffInMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  return `${diffInMonths} months`;
};